import React from 'react';
import { APITypes, MedicalDataTypes, Dynamo } from '../../../../primary-record-types';
import ProcedureFormImpl from './Form';
import RenderWithProviders from '../RenderWithProviders';

export type ProcedureFormOwnProps = {
    isLoading: boolean;
    startDateTime?: string;
    defaultResource?: MedicalDataTypes.PrimaryRecordProcedure;
    defaultImages?: Dynamo.ResourceImage[];
    onSubmit: (data: APITypes.medicalDataService.UpdateResourceBody<MedicalDataTypes.PrimaryRecordProcedure>) => void;
    isDisabled: boolean;
    profileId: string;
    resourceId?: string;
    onCancel: () => void;
};

export type ProcedureFormProps = ProcedureFormOwnProps;

const ProcedureForm: React.FC<ProcedureFormProps> = (props) => {
    return (
        <RenderWithProviders
            medicalProfileId={props.profileId}
            render={(providers) => <ProcedureFormImpl {...props} providers={providers} />}
        />
    );
};

export default React.memo(ProcedureForm);
